import React, { FunctionComponent } from 'react';

import withIconContainer from './withIconContainer';

const IconCardJCB: FunctionComponent = () => (
    <svg
        aria-labelledby="iconCardJCBTitle"
        fill="none"
        height="48"
        viewBox="0 0 70 48"
        width="70"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title id="iconCardJCBTitle">JCB</title>
        <rect fill="white" height="47" rx="5.5" stroke="#D9D9D9" width="69" x="0.5" y="0.5" />
        <path
            d="M44.6363 24.5747C45.6637 24.597 46.6969 24.5293 47.7201 24.6098C48.7564 24.8032 49.0061 26.3719 48.0855 26.8857C47.4573 27.2242 46.7111 27.0118 46.0301 27.0715H44.6363V24.5747ZM48.3142 21.7486C48.5424 22.5543 47.7657 23.2777 46.9898 23.1667H44.6363C44.6529 22.4069 44.6041 21.5823 44.6602 20.8625C45.603 20.8891 46.5545 20.8084 47.4919 20.9047C47.8946 21.0059 48.2317 21.337 48.3142 21.7486ZM53.9781 9.80096C54.0219 11.3396 53.9844 12.9595 53.997 14.5293C53.9941 20.9116 54.0031 27.2937 53.992 33.6763C53.9506 36.0683 51.8308 38.1467 49.4555 38.1944C47.0778 38.2041 44.6998 38.1959 42.3218 38.1985V28.5498C44.9127 28.5365 47.505 28.577 50.0949 28.5296C51.2963 28.4542 52.6123 27.6615 52.6682 26.3393C52.8097 25.0114 51.5578 24.093 50.3692 23.9479C49.9123 23.936 49.9256 23.8147 50.3692 23.7618C51.5028 23.5168 52.3931 22.3435 52.0595 21.1684C51.7753 19.9325 50.4093 19.4541 49.273 19.4565C46.9563 19.4408 44.6391 19.4543 42.3223 19.4497C42.3373 17.6484 42.2911 15.8452 42.3472 14.0452C42.5308 11.6965 44.7039 9.75955 47.0459 9.80157C49.3569 9.80122 51.6676 9.80122 53.9781 9.80114V9.80096Z"
            fill="url(#paint0_linear_669_3451)"
        />
        <path
            d="M16.1412 14.2885C16.2003 11.9003 18.3292 9.83898 20.7015 9.80407C23.0704 9.79678 25.4396 9.80302 27.8085 9.80091C27.802 17.7911 27.8213 25.7821 27.7987 33.7719C27.7075 36.131 25.6018 38.153 23.2554 38.1948C20.882 38.2034 18.5084 38.196 16.1349 38.1984V28.2244C18.4403 28.769 20.8579 29.0009 23.2098 28.6396C24.6157 28.4134 26.1538 27.723 26.6298 26.2645C26.9801 25.0169 26.7829 23.7039 26.835 22.4234V19.4497H22.7648C22.7465 21.4164 22.8023 23.3866 22.7353 25.351C22.6256 26.5584 21.4299 27.3256 20.2911 27.2846C18.8789 27.2995 16.0803 26.2611 16.0803 26.2611C16.0732 22.5762 16.1212 17.9615 16.1412 14.2888V14.2885Z"
            fill="url(#paint1_linear_669_3451)"
        />
        <path
            d="M29.3264 20.6492C29.1121 20.6947 29.2833 19.9194 29.2285 19.6254C29.2431 17.766 29.198 15.9045 29.2534 14.0464C29.4365 11.6878 31.6263 9.74599 33.9778 9.8012H40.9026C40.8961 17.7914 40.9154 25.7824 40.8929 33.7721C40.8015 36.1313 38.6957 38.1532 36.3492 38.1951C33.9757 38.204 31.6021 38.1965 29.2284 38.1988V27.2709C30.8495 28.601 33.0527 28.808 35.0723 28.8116C36.5948 28.8111 38.1084 28.5764 39.587 28.2252V26.2232C37.9207 27.0537 35.962 27.5812 34.1149 27.104C32.8264 26.7833 31.8911 25.5381 31.912 24.2084C31.7627 22.8256 32.5732 21.3656 33.9321 20.9546C35.6193 20.4264 37.4581 20.8303 39.0396 21.517C39.3784 21.6945 39.7224 21.9145 39.5869 21.3482V19.7746C36.9419 19.1453 34.127 18.9137 31.4697 19.5983C30.7006 19.8153 29.9512 20.1443 29.3264 20.6494V20.6492Z"
            fill="url(#paint2_linear_669_3451)"
        />
        <defs>
            <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint0_linear_669_3451"
                x1="42.2421"
                x2="53.9233"
                y1="23.3926"
                y2="23.3926"
            >
                <stop stopColor="#58B03A" />
                <stop offset="1" stopColor="#55B330" />
            </linearGradient>
            <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint1_linear_669_3451"
                x1="15.8866"
                x2="27.6171"
                y1="24.2716"
                y2="24.2716"
            >
                <stop stopColor="#0F6EB6" />
                <stop offset="1" stopColor="#006DBA" />
            </linearGradient>
            <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint2_linear_669_3451"
                x1="29.2113"
                x2="40.9004"
                y1="23.6679"
                y2="23.6679"
            >
                <stop stopColor="#DE0D3D" />
                <stop offset="1" stopColor="#E30138" />
            </linearGradient>
        </defs>
    </svg>
);

export default withIconContainer(IconCardJCB);
